import { theme } from '@chakra-ui/react';

const fontSizes = {
  ...theme.fontSizes,
  lg: '1.15625rem',
};

export default fontSizes;
